import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import ReactGA from 'react-ga';

import * as types from './types';
import utils from '../lib/utils';
import history from '../lib/history';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION);
// .set('X-Request-ID', uuidv4())
export function userCreateStart() {
  return {
    type: types.REGISTER_USER_START,
  };
}

export function userCreateSuccess({ user, domain, status }) {
  // Save user in local storage
  utils.setCookie('user', user);
  if (status !== null && status !== undefined) {
    utils.setCookie('subscription_status', status);
  }
  // Save domain in cookie
  utils.setCookie('domain', domain);
  let userObj = { user, domain, subscription_status: status };
  return {
    type: types.REGISTER_USER_SUCCESS,
    userObj,
  };
}

export function userCreateError(errormessage) {
  return {
    type: types.REGISTER_USER_ERROR,
    errormessage,
  };
}

export function userLoginStart() {
  utils.removeCookie('user');
  utils.removeCookie('subscription_status');
  utils.removeCookie('features');
  utils.removeCookie('domain_keywords');
  utils.removeCookie('booking_software');
  utils.removeCookie('brand_ids');
  utils.removeCookie('studio_id');
  utils.removeCookie('studio_name');
  utils.removeCookie('role');
  utils.removeCookie('dashboard_settings');
  utils.removeCookie('is_phone_assigned');
  utils.removeCookie('tl_user_login');
  utils.removeCookie('weave_phone');
  localStorage.clear();
  sessionStorage.clear();
  // Save domain in cookie
  utils.removeCookie('domain');
  return {
    type: types.LOGIN_USER_START,
  };
}

export function userLoginSuccess({
  user,
  domain,
  status,
  features,
  domain_keywords,
  booking_software,
  header,
  brand_ids,
  studio_id,
  studio_name,
  role,
  dashboard_settings,
  is_phone_assigned,
  is_brand,
  weave_phone,
}) {
  console.log('header', header);
  // Save user in local storage
  utils.setCookie('user', user);
  utils.setCookie('subscription_status', status);
  utils.setCookie('features', features);
  utils.setCookie('domain_keywords', domain_keywords);
  utils.setCookie('booking_software', booking_software);
  utils.setCookie('brand_ids', brand_ids);
  utils.setCookie('studio_id', studio_id);
  utils.setCookie('studio_name', studio_name);
  utils.setCookie('role', role);
  utils.setCookie('dashboard_settings', dashboard_settings);
  utils.setCookie('is_phone_assigned', is_phone_assigned);
  utils.setCookie('tl_user_login', true);
  utils.setCookie('is_brand', is_brand);
  utils.setCookie('weave_phone', weave_phone);
  utils.removeCookie('authe');
  utils.removeCookie('authp');
  // Save domain in cookie
  utils.setCookie('domain', domain);
  ReactGA.set({ dimension4: user });
  let userObj = {
    user,
    domain,
    subscription_status: status,
    features,
    domain_keywords,
    booking_software,
    brand_ids,
    studio_id,
    studio_name,
    role,
    dashboard_settings,
    is_phone_assigned,
    is_brand,
    weave_phone,
  };
  return {
    type: types.LOGIN_USER_SUCCESS,
    userObj,
  };
}

export function userLoginError() {
  return {
    type: types.LOGIN_USER_ERROR,
  };
}

export function userLoginInternalError() {
  return {
    type: types.LOGIN_USER_INTERNAL_ERROR,
  };
}

export function userNotRegistered(message) {
  return {
    type: types.LOGIN_USER_NOT_REGISTERED,
    message,
  };
}

export function userUnsubscribed(message) {
  return {
    type: types.LOGIN_USER_UNSUBSCRIBED,
    message,
  };
}

export function userLogout() {
  // Remove saved user from local storage
  const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
  const logout_data = JSON.parse(localStorage.getItem('logout'));
  console.log('logout');
  return (dispatch) => {
    dispatch(LogoutStart());
    utils.removeCookie('tl_user_login');
    return request
      .post(`${window.Config.API_URL}/business/logout`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then(() => {
        const role = utils.getCookie('role') || logout_data?.role;
        utils.removeCookie('user');
        utils.removeCookie('domain');
        utils.removeCookie('subscription_status');
        utils.removeCookie('features');
        utils.removeCookie('booking_software');
        utils.removeCookie('brand_ids');
        utils.removeCookie('studio_id');
        utils.removeCookie('studio_name');
        utils.removeCookie('role');
        utils.removeCookie('dashboard_settings');
        utils.removeCookie('tl_user_login');
        utils.removeCookie('is_brand');
        utils.removeCookie('weave_phone');
        utils.removeCookie('cs_authe');
        utils.removeCookie('cs_authp');
        localStorage.setItem('logout', JSON.stringify({
          timestamp: Date.now(),
          role,
        }));
        dispatch(LogoutSuccess());
        if (csroles.includes(role)) {
          history.push('/cslogin');
        } else {
          history.push('/login');
        }
      })
      .catch((ex) => {
        const role = utils.getCookie('role') || logout_data?.role;
        utils.removeCookie('user');
        utils.removeCookie('domain');
        utils.removeCookie('subscription_status');
        utils.removeCookie('features');
        utils.removeCookie('booking_software');
        utils.removeCookie('brand_ids');
        utils.removeCookie('studio_id');
        utils.removeCookie('studio_name');
        utils.removeCookie('role');
        utils.removeCookie('dashboard_settings');
        utils.removeCookie('tl_user_login');
        utils.removeCookie('is_brand');
        utils.removeCookie('weave_phone');
        utils.removeCookie('cs_authe');
        utils.removeCookie('cs_authp');
        dispatch(LogoutFailure());
        if (csroles.includes(role)) {
          history.push('/cslogin');
        } else {
          history.push('/login');
        }
      });
  };
}

export function LogoutSuccess() {
  return {
    type: types.LOGOUT_USER,
  };
}
export function LogoutFailure() {
  return {
    type: types.LOGOUT_USER,
  };
}
export function LogoutStart() {
  return {
    type: types.LOGOUT_START,
  };
}

export function unauthorizedAccess() {
  return {
    type: types.UNAUTHORIZED_ACCESS,
  };
}

export function forgotPasswordSuccess() {
  return {
    type: types.FORGOT_PASSWORD_SUCCESS,
  };
}

export function forgotPasswordError() {
  return {
    type: types.FORGOT_PASSWORD_ERROR,
  };
}

export function getForgotPasswordSuccess() {
  return {
    type: types.GET_FORGOT_PASSWORD_SUCCESS,
  };
}

export function getForgotPasswordError() {
  return {
    type: types.GET_FORGOT_PASSWORD_ERROR,
  };
}

export function postResetPasswordStart() {
  return {
    type: types.POST_RESET_PASSWORD_START,
  };
}

export function postResetPasswordSuccess() {
  return {
    type: types.POST_RESET_PASSWORD_SUCCESS,
  };
}

export function postResetPasswordFail() {
  return {
    type: types.POST_RESET_PASSWORD_ERROR,
  };
}

export function forgotPasswordReset() {
  return {
    type: types.FORGOT_PASSWORD_RESET,
  };
}

export function postUser(user) {
  return (dispatch) => {
    dispatch(userCreateStart());

    const headers = {
      Authorization: user.password,
    };

    const reqUser = Object.assign({}, user);
    delete reqUser.password;

    return request
      .post(`${window.Config.API_URL}/signup`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .auth(user.email, headers.Authorization)
      .send(reqUser)
      .ok((resp) => resp.status < 501)
      .then((resp) => {
        if (resp.statusCode === 200) {
          const responseData = resp?.body?.data || {};
          dispatch(
            userCreateSuccess({
              user: responseData.id,
              domain: responseData.domain,
              status: responseData.subscription_status || null,
            }),
          );
        } else {
          console.log('resp', resp);
          dispatch(userCreateError(resp?.body?.message));
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(userCreateError());
      });
  };
}

export function postLogin(user) {
  return (dispatch) => {
    dispatch(userLoginStart());

    const headers = {
      Authorization: user.password,
    };
    // const agent =  request.agent();
    const tail = user.business_id ? `/login?business_id=${user.business_id}` : '/login';
    return request
      .post(`${window.Config.API_URL}${tail}`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .auth(user.email, headers.Authorization)
      .ok((resp) => resp.status < 501)
      .then((resp) => {
        console.log('resp', resp.headers);
        if (resp.statusCode === 200) {
          // Persist CS credentials for header business switch
          const csRoles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
          if (csRoles.includes(resp.body.data.role)) {
            utils.setCookie('cs_authe', user.email);
            utils.setCookie('cs_authp', user.password);
          }
          dispatch(
            userLoginSuccess({
              user: resp.body.data.id,
              domain: resp.body.data.domain,
              status: resp.body.data.subscription_status,
              features: resp.body.data.features,
              domain_keywords: resp.body.data.domain_keywords,
              booking_software: resp.body.data.booking_software,
              brand_ids: resp.body.data.brand_ids,
              studio_id: resp.body.data.studio_id,
              studio_name: resp.body.data.studio_name,
              is_phone_assigned: resp.body.data.is_phone_assigned,
              role: resp.body.data.role,
              is_brand: resp.body.data.is_brand,
              dashboard_settings:
                resp.body.data.dashboard_settings.show_notifications || false,
              header: resp,
              weave_phone: resp.body.data.weave_phone,
            }),
          );
          dispatch(checkVersionMisMatch(resp.headers));
        } else if (resp.status === 404) {
          dispatch(userNotRegistered(resp.body.message));
          dispatch(checkVersionMisMatch(resp.headers));
        } else if (resp.status === 403) {
          dispatch(userUnsubscribed(resp.body.message));
          dispatch(checkVersionMisMatch(resp.headers));
        } else if (
          Math.floor(resp.status / 100) === 5 ||
          resp.message.indexOf('offline') !== -1
        ) {
          dispatch(userLoginInternalError(resp.body.message));
        } else {
          dispatch(userLoginError());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(userLoginError());
      });
  };
}

export function postForgotPassword({ email }) {
  return (dispatch) => {
    const reqUser = Object.assign({
      email,
    });

    return request
      .post(`${window.Config.API_URL}/client/forgotPassword`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(reqUser)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(forgotPasswordSuccess());
          dispatch(checkVersionMisMatch(resp.headers));
        } else if (resp.statusCode === 400) {
          dispatch(forgotPasswordError());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(forgotPasswordError());
      });
  };
}

export function getForgotPassword(fpId) {
  return (dispatch) => {
    const reqResetPassword = {
      ID: fpId,
    };

    return request
      .get(`${window.Config.API_URL}/client/forgotPassword`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .query(reqResetPassword)
      .then(() => {
        dispatch(getForgotPasswordSuccess());
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getForgotPasswordError());
      });
  };
}

export function postResetPassword({ requestId, newPassword }) {
  return (dispatch) => {
    dispatch(postResetPasswordStart());

    const reqReset = Object.assign({
      requestId,
      newPassword,
    });

    return request
      .post(`${window.Config.API_URL}/client/resetPassword`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(reqReset)
      .then(() => {
        dispatch(postResetPasswordSuccess());
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postResetPasswordFail());
      });
  };
}

const getUserStart = () => {
  return {
    type: types.GET_USER_START,
  };
};

const getUserSuccess = ({ user }) => {
  console.log('User', user);
  return {
    type: types.GET_USER_SUCCESS,
    user,
  };
};

const getUserFail = () => {
  return {
    type: types.GET_USER_FAIL,
  };
};

export function getUser() {
  return (dispatch) => {
    dispatch(getUserStart());
    return request
      .get(`${window.Config.API_URL}/business/client`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        const user = JSON.parse(resp.body.message);
        console.log('User', user);
        dispatch(getUserSuccess({ user }));
      })
      .catch((ex) => {
        console.log('Failed to fetch user', ex);
        dispatch(getUserFail());
      });
  };
}

const getStripeUserStart = () => {
  return {
    type: types.GET_STRIPE_USER_START,
  };
};

const getStripeUserSuccess = ({ stripe_user }) => {
  console.log('stripe_user', stripe_user);
  return {
    type: types.GET_STRIPE_USER_SUCCESS,
    stripe_user,
  };
};

const getStripeUserFail = () => {
  return {
    type: types.GET_STRIPE_USER_FAIL,
  };
};

export function getStripeUser(billing_id) {
  return (dispatch) => {
    dispatch(getStripeUserStart());
    return request
      .post(`${window.Config.API_URL}/configure/billing_id/verify`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send({ billing_id })
      .then((resp) => {
        if (resp.statusCode === 200) {
          console.log('stripe_user', resp.body);
          dispatch(getStripeUserSuccess({ stripe_user: resp.body }));
        } else if (resp.statusCode === 400) {
          dispatch(forgotPasswordError());
        }
      })
      .catch((ex) => {
        console.log('Failed to fetch user', ex);
        dispatch(getStripeUserFail());
      });
  };
}

export function forbiddenAccess() {
  history.push('/app/forbidden');
}

export function versionMisMatchFalse() {
  return {
    type: types.VERSION_MISMATCH_FALSE,
  };
}

export function checkVersionMisMatch(headers) {
  return {
    type: types.VERSION_MISMATCH_FALSE,
    headers,
  };
}

export function validateCSCredsStart() {
  return {
    type: types.VALIDATE_CS_USER_START,
  };
}

export function validateCSCredsSuccess() {
  return {
    type: types.VALIDATE_CS_USER_SUCCESS,
  };
}

export function validateCSCredsFail() {
  return {
    type: types.VALIDATE_CS_USER_FAIL,
  };
}

export function validateUser({ email, password }) {
  return (dispatch) => {
    dispatch(validateCSCredsStart());
    return request
      .get(`${window.Config.API_URL}/verify_user`)
      .auth(email, password)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .ok((resp) => resp.status < 501)
      .then((resp) => {
        console.log('resp', resp.headers);
        if (resp.statusCode === 200) {
          dispatch(validateCSCredsSuccess());
        }
      })
      .catch((ex) => {
        console.log('Failed to fetch user', ex);
        dispatch(validateCSCredsFail());
      });
  };
}
